export const ICON_PATHS = {
  filter_alt: "/assets/icons/filter_alt.svg",
  logout: "/assets/icons/logout.svg",
  person_outline: "/assets/icons/person_outline.svg",
  falabella_logo: "/assets/icons/falabella_logo.svg",
  warning_outline: "/assets/icons/warning_outline.svg",
  error_outline: "/assets/icons/error_outline.svg",
  info: "/assets/icons/info.svg",
  search: "/assets/icons/search.svg",
  close: "/assets/icons/close.svg",
  image: "/assets/icons/image.svg",
  trash: "/assets/icons/trash.svg",
  download: "/assets/icons/download.svg",
  excel: "/assets/icons/excel_icon.svg",
  history: "/assets/icons/history.svg",
  eye: "/assets/icons/eye.svg",
  file: "/assets/icons/file.svg",
  check: "/assets/icons/check.svg",
  chevron_left: "/assets/icons/chevron_left.svg",
  chevron_right: "/assets/icons/chevron_right.svg",
  event: "/assets/icons/event.svg",
  arrow_drop_down: "/assets/icons/arrow_drop_down.svg",
  arrow_drop_up: "/assets/icons/arrow_drop_up.svg",
} as const;
